<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
    <nb-card-header>
      {{ 'product_assigned_menu' | translate }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="d-flex mx-0 mt-2 justify-content-between">
        <nb-select class="col-auto pr-0 ml-auto" style="width:180px" [(ngModel)]="selectPRDMenuNo" (selectedChange)="onQuery()">
          <nb-option *ngFor="let item of titleList" [value]="item.value">
            {{ item.label }}
          </nb-option>
        </nb-select>
      </div>

      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ 'product_menu_category' | translate }}</th>
              <th>{{ 'product_menu' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of mainDataList">
              <tr>
                <td>{{ e.GroupName }}</td>
                <td style="vertical-align: middle;">{{e.Title}}</td>
                <td>
                  <button nbButton class="m-0 col-sm-12" (click)="onOpenPd(e.PRDMenuProductGroupNo)">{{ 'common_view' | translate }}</button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="ref.close()">{{ 'common_close' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #PdModal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>
      {{ 'common_product_name' | translate }}
    </nb-card-header>
    <nb-card-body class="staffInfoTemplate">
      <div class="mt-3">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ 'common_product_name' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let e of showListPd">
              <tr>
                <td>{{ e.ProductName }}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="ref.close()">{{ 'common_close' | translate }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
